import {
    DEFAULT_RECOMMENDATION_TYPE,
    QueryBuilderFields,
    RecommendationTypeEnum,
    RECOMMENDATION_TYPE_ATTRIBUTE,
    TARGET_AREA_ATTRIBUTE
} from '../SPAConstants';

export const isTargetAreaSelectionValid = (
    campaignSummary: { [key: string]: string | undefined }
) => {
    const recommendationType = campaignSummary[RECOMMENDATION_TYPE_ATTRIBUTE] || DEFAULT_RECOMMENDATION_TYPE;
    return recommendationType !== RecommendationTypeEnum.LOCAL
        || Boolean(campaignSummary[TARGET_AREA_ATTRIBUTE]?.trim());
};

export const getTargetAreaQuery = (
    campaignSummary: { [key: string]: string | undefined },
    datasetFields: { [key: string]: unknown }
) => {
    const recommendationType = campaignSummary[RECOMMENDATION_TYPE_ATTRIBUTE] || DEFAULT_RECOMMENDATION_TYPE;
    const targetArea = campaignSummary[TARGET_AREA_ATTRIBUTE];

    if (recommendationType !== RecommendationTypeEnum.LOCAL) {
        return '';
    }

    if (!targetArea?.trim()) {
        return '1=0';
    }

    const areaField = Object.keys(datasetFields).find(
        field => field.toLowerCase() === QueryBuilderFields.Area.toLowerCase()
    );

    if (!areaField) {
        return '1=0';
    }

    return `${areaField} = '${targetArea.trim().replaceAll("'", "''")}'`;
};
